export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";